import client, { getResponseData } from './client';
export const getDetails = (id) => {
	return client.get(`applications/${id}`);
};

export const updateDetails = (data) => {
	return client({
		url: `applications/update`,
		method: 'post',
		data,
	});
};

// applications data will be like:
// [{
// 	"id": 1,
// 	"application_name": "test App 1",
// 	"description": "test app 1",
// 	"createdAt": "2026-01-29T07:17:50.354Z",
// 	"updatedAt": "2026-01-29T07:17:50.354Z",
// 	"createdBy": null,
// 	"updatedBy": null
// }, ...]
export const getApplications = () => {
	return client.get('application').then((res) => getResponseData(res));
};

export const addApplication = (data) => {
	return client({
		url: 'application',
		method: 'post',
		data,
	});
};

// application data will be like:
// {
// 	"application": {
// 		"id": 2,
// 		"applicationName": "Test App 2",
// 		"description": "test app 2",
// 		"createdAt": "2026-02-02T06:33:18.483Z",
// 		"updatedAt": "2026-02-02T06:33:18.483Z",
// 		"createdBy": null,
// 		"updatedBy": null
// 	},
// 	"applicationAttributeList": [
// 		{
// 				"attributeName": "key 1",
// 				"attributeValue": "val1",
// 				"applicationId": 2,
// 				"id": 2
// 		}
// 	]
// }
export const getApplication = (id) => {
	return client.get(`application/${id}`).then((res) => getResponseData(res));
};

export const updateApplication = (id, data) => {
	return client({
		url: `application/${id}`,
		method: 'put',
		data,
	});
};
